// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3anB5","content":"styles_content__R9QUN"};